// src/services/apiClient.ts
import { useAuthStore } from '@/stores/auth'
import axios, { AxiosError } from 'axios'

// 創建一個 Axios 實例
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 請求攔截器：只處理基本配置
apiClient.interceptors.request.use(
  (config) => {
    // 檢查是否需要跳過 token
    if (config.headers?.['Skip-Auth']) {
      delete config.headers['Skip-Auth']
    }
    return config
  },
  (error) => Promise.reject(error),
)

// 響應攔截器：處理全局錯誤，例如 401 未授權
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ code?: string; message?: string }>) => {
    // 任何 401 都視為未授權：清 token + 導回登入頁
    if (error.response?.status === 401) {
      // Zustand store 在 React 之外要用 getState()，不能直接呼叫 hook
      useAuthStore.getState().clearToken()
      // 已在 /login 就不再 reload，避免死迴圈與 in-flight 401 連環觸發
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

export { apiClient }
